module.exports = __webpack_public_path__ + "static/media/side_menu.b1ddab4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/side_menu.svg
// module id = 276
// module chunks = 0